<script>

import axios from 'axios';
const urlSolicistacao = process.env.VUE_APP_API_URL+"documentos-personalizados";

export default class PropostaDcoumentosRepository{
    

    async createDocumento(token,data) {
        
        const baseURL = urlSolicistacao;
        const headers = {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Authorization': 'Bearer ' + token
        };
        const response = await axios.post(baseURL,data,{ headers });
        return response;
       
    }

}
</script>
